import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ChargesList.scss';
import { Charge } from 'lane-shared/domains/billingPayments/types';
import { type SupportedPaymentCurrency } from 'domains-billing-currency';
import { Flex, ToggleView } from 'components';
import { SupportedLocaleEnum } from 'localization';
import {
  ChargeListItem,
  ChargeStatusVisibility,
} from './ChargeListItem/ChargeListItem';
import { useWorkOrdersServiceRequestInvoicingOptionsEnabled } from 'react-hooks';

export function ChargesList({
  charges,
  currency,
  locale,
  voidCharge,
  showSRChargeStatus = true,
  channelSlug,
  showVoidOption,
}: {
  charges: Charge[];
  currency: SupportedPaymentCurrency;
  locale: SupportedLocaleEnum;
  voidCharge: (chargeId: string) => Promise<void>;
  showSRChargeStatus: boolean;
  channelSlug?: string;
  showVoidOption?: boolean;
}) {
  const { t } = useTranslation();
  const isWorkOrdersServiceRequestInvoicingOptionsEnabled =
    useWorkOrdersServiceRequestInvoicingOptionsEnabled();

  let showChargeStatus: ChargeStatusVisibility = 'always';

  if (isWorkOrdersServiceRequestInvoicingOptionsEnabled) {
    showChargeStatus = showSRChargeStatus ? 'yes' : 'no';
  }

  return (
    <ToggleView
      title={`${t`abp.charges.chargeManager.list.title`} (${charges.length})`}
      className={styles.Title}
      defaultExpanded
    >
      <Flex 
        direction="column" 
        gap={5} 
        width="full"
        data-test="billing-charges-list"
      >
        {charges.map((charge, index) => (
          <ChargeListItem
            charge={charge}
            currency={currency}
            locale={locale}
            voidCharge={() => voidCharge(charge.id)}
            key={charge.id || index}
            showSRChargeStatus={showChargeStatus}
            channelSlug={channelSlug}
            showVoidOption={showVoidOption}
          />
        ))}
      </Flex>
    </ToggleView>
  );
}
